import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const Demo = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar staticHeader />
      
      <main className="flex-1">
        {/* Hero Section with Video */}
        <section className="relative overflow-hidden pt-28 sm:pt-36 pb-16 border-b border-border">
          <div
            className="absolute inset-0 -z-10 bg-cover bg-center opacity-[0.14]"
            style={{ backgroundImage: "url('/hero-bg.png')" }}
            aria-hidden
          />
          <div className="absolute inset-0 -z-10 bg-gradient-to-b from-background/70 via-background/92 to-background" aria-hidden />

          <div className="container mx-auto px-4">
            <div className="max-w-3xl mb-12">
              <div className="flex items-center gap-3 mb-6">
                <span className="rule-gold" aria-hidden />
                <p className="eyebrow">Live walkthrough</p>
              </div>
              <h1 className="text-4xl sm:text-5xl md:text-[3.25rem] font-semibold leading-[1.06] mb-6">
                See AuthorPro <span className="text-gold-gradient">in action.</span>
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Watch how a finished book becomes an interactive, AI-powered platform — assessments,
                personalised reports, and a pipeline of qualified readers.
              </p>
            </div>

            <div className="card-noir overflow-hidden p-2 md:p-3">
              <video className="w-full rounded-sm" controls preload="metadata">
                <source
                  src="https://wptkfejcdnjjftwmwuof.supabase.co/storage/v1/object/public/authorpro-brand/Demo/a3cf8c24-8b58-440a-be44-970d59d96f17_1761069691304.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </section>


        {/* Case Study Section */}
        <section className="py-20 md:py-28 bg-card border-b border-border">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-5">
                <span className="rule-gold" aria-hidden />
                <p className="eyebrow">Success story</p>
              </div>
              <h2 className="text-3xl sm:text-4xl font-semibold leading-[1.1] mb-4">
                Prosper With Purpose
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Helping consultants build stronger, more profitable businesses with less stress — powered
                by the author's own frameworks.{" "}
                <a
                  href="https://prosperwithpurpose.ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gold hover:underline"
                >
                  Visit the platform
                </a>
              </p>
            </div>


            <div style={{ position: "relative", paddingBottom: "calc(51.6146% + 41px)", height: "0px", width: "100%" }}>
              <iframe 
                src="https://demo.arcade.software/S14Fks0qb2sOL1uLoPXk?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true" 
                title="Analyze Business Health Using a Website URL" 
                frameBorder="0" 
                loading="lazy" 
                allowFullScreen 
                allow="clipboard-write" 
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", colorScheme: "light" }}
              />
            </div>
          </div>
        </section>

        {/* Request Demo Section */}
        <section className="py-20 md:py-28">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="card-noir relative overflow-hidden p-8 md:p-11">
              <span className="absolute inset-x-0 top-0 h-px gold-hairline" aria-hidden />
              <p className="eyebrow mb-5">Request a demo</p>
              <h2 className="text-3xl sm:text-4xl font-semibold leading-[1.1] mb-4">
                Prefer a walkthrough of your own book?
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-10 max-w-2xl">
                Book a personalised session and we will show you exactly what your book could become —
                using your chapters, your frameworks, your audience.
              </p>

              <div className="grid gap-10 md:grid-cols-2 mb-10">
                <div>
                  <h3 className="eyebrow mb-4 !text-muted-foreground">What you'll see</h3>
                  <ul className="space-y-3 text-[15px] text-muted-foreground">
                    {[
                      "Interactive AI book chat in action",
                      "Automated report generation",
                      "Lead capture and client management",
                      "Analytics dashboard overview",
                    ].map((i) => (
                      <li key={i} className="flex gap-3">
                        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-gold" aria-hidden />
                        {i}
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3 className="eyebrow mb-4 !text-muted-foreground">Perfect for</h3>
                  <ul className="space-y-3 text-[15px] text-muted-foreground">
                    {[
                      "Published authors and experts",
                      "Business consultants and coaches",
                      "Industry thought leaders",
                      "Professional service providers",
                    ].map((i) => (
                      <li key={i} className="flex gap-3">
                        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-gold" aria-hidden />
                        {i}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <Button asChild size="lg" className="bg-gold text-gold-foreground hover:bg-gold-light font-semibold px-8 w-full sm:w-auto">
                <a href="https://meetings.series-a.co/meetings/series-a/authorpro" target="_blank" rel="noopener noreferrer">
                  Book Your Free Demo
                </a>
              </Button>
            </div>
          </div>
        </section>


        {/* Additional Resources Section */}
      </main>

      <Footer />
    </div>
  );
};

export default Demo;
